export class CoachingTemplatesUser {
    public userId: String;
    public coachingTemplateIds: String[];

    constructor(raw: object) {
        this.userId = raw['userId'];
        this.coachingTemplateIds = raw['coachingTemplateIds'];
    }
}